import * as $runtime from "../runtime.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import {
  catchDecodingErrorImpl,
  decodeArray,
  decodeBoolean,
  decodeInt,
  decodeNumber,
  decodeObject,
  decodeRecord,
  decodeString,
  decodingError,
  expectArray,
  expectObject,
  isNumber,
  isString,
  recordInfoCons,
  recordInfoNil,
  unsafeParseJSON
} from "./foreign.js";
const $FromJSONKeyFunction = (tag, _1) => ({tag, _1});
const FromJSONKeyString = value0 => $FromJSONKeyFunction("FromJSONKeyString", value0);
const FromJSONKeyValue = value0 => $FromJSONKeyFunction("FromJSONKeyValue", value0);
const fromJSONKeyString = {fromJSONKey: /* #__PURE__ */ $FromJSONKeyFunction("FromJSONKeyString", x => x)};
const decodeUnit = {unsafeDecode: v => {}};
const decodeString1 = {unsafeDecode: decodeString};
const decodeRecordNil = {recordInfo: v => recordInfoNil};
const decodeNumber1 = {unsafeDecode: decodeNumber};
const decodeInt1 = {unsafeDecode: decodeInt};
const decodeForeign = {unsafeDecode: x => x};
const decodeBoolean1 = {unsafeDecode: decodeBoolean};
const unsafeDecode = dict => dict.unsafeDecode;
const decodeArray1 = dictDecode => ({unsafeDecode: decodeArray(dictDecode.unsafeDecode)});
const decodeMaybe = dictDecode => (
  {
    unsafeDecode: value => {
      if (Foreign.isNull(value) || Foreign.isUndefined(value)) { return Data$dMaybe.Nothing; }
      return Data$dMaybe.$Maybe("Just", dictDecode.unsafeDecode(value));
    }
  }
);
const decodeNonEmptyArray = dictDecode => {
  const unsafeDecode2 = dictDecode.unsafeDecode;
  return {
    unsafeDecode: f => {
      const $0 = decodeArray(unsafeDecode2)(f);
      if ($0.length > 0) { return $0; }
      return decodingError("NonEmptyArray should not be empty");
    }
  };
};
const decodeObject1 = dictDecode => ({unsafeDecode: decodeObject(dictDecode.unsafeDecode)});
const decodeSet = dictDecode => {
  const unsafeDecode2 = dictDecode.unsafeDecode;
  return dictOrd => (
    {
      unsafeDecode: (() => {
        const $0 = Data$dFoldable.foldlArray(m => a => Data$dMap$dInternal.insert(dictOrd)(a)()(m))(Data$dMap$dInternal.Leaf);
        const $1 = decodeArray(unsafeDecode2);
        return x => $0($1(x));
      })()
    }
  );
};
const decodeTuple = dictDecode => dictDecode1 => (
  {
    unsafeDecode: v => {
      const v1 = expectArray(v);
      if (v1.length === 2) { return Data$dTuple.$Tuple(dictDecode.unsafeDecode(v1[0]), dictDecode1.unsafeDecode(v1[1])); }
      return decodingError("Invalid array length in Tuple representation");
    }
  }
);
const unsafeDecode1 = /* #__PURE__ */ (() => decodeArray(decodeTuple(decodeForeign)(decodeForeign).unsafeDecode))();
const recordInfo = dict => dict.recordInfo;
const decodeRecord1 = () => dictDecodeRecord => ({unsafeDecode: decodeRecord(dictDecodeRecord.recordInfo(Type$dProxy.Proxy))});
const decodeRecordCons = dictIsSymbol => dictDecode => {
  const unsafeDecode2 = dictDecode.unsafeDecode;
  return dictDecodeRecord => ({recordInfo: v => recordInfoCons(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(unsafeDecode2)(dictDecodeRecord.recordInfo(Type$dProxy.Proxy))});
};
const fromJSONKey = dict => dict.fromJSONKey;
const decodeMap = dictFromJSONKey => {
  const fromJSONKey1 = dictFromJSONKey.fromJSONKey;
  return dictOrd => dictDecode => (
    {
      unsafeDecode: v => {
        if (fromJSONKey1.tag === "FromJSONKeyString") {
          return Foreign$dObject.fold(b => a => v2 => Data$dMap$dInternal.insert(dictOrd)(fromJSONKey1._1(a))(dictDecode.unsafeDecode(v2))(b))(Data$dMap$dInternal.Leaf)(expectObject(v));
        }
        if (fromJSONKey1.tag === "FromJSONKeyValue") {
          return Data$dFoldable.foldlArray(acc => v2 => Data$dMap$dInternal.insert(dictOrd)(fromJSONKey1._1(v2._1))(dictDecode.unsafeDecode(v2._2))(acc))(Data$dMap$dInternal.Leaf)(unsafeDecode1(v));
        }
        $runtime.fail();
      }
    }
  );
};
const defaultFromJSONKeyValue = dictDecode => $FromJSONKeyFunction("FromJSONKeyValue", dictDecode.unsafeDecode);
const catchDecodingErrorEither = /* #__PURE__ */ catchDecodingErrorImpl(Data$dEither.Left)(Data$dEither.Right);
const decodeEither = dictDecode => value => catchDecodingErrorEither(v => dictDecode.unsafeDecode(value));
const decodeJSONEither = dictDecode => value => catchDecodingErrorEither(v => dictDecode.unsafeDecode(unsafeParseJSON(value)));
const catchDecodingError = /* #__PURE__ */ catchDecodingErrorImpl(v => Data$dMaybe.Nothing)(Data$dMaybe.Just);
const decode = dictDecode => value => catchDecodingError(v => dictDecode.unsafeDecode(value));
const decodeJSON = dictDecode => value => catchDecodingError(v => dictDecode.unsafeDecode(unsafeParseJSON(value)));
export {
  $FromJSONKeyFunction,
  FromJSONKeyString,
  FromJSONKeyValue,
  catchDecodingError,
  catchDecodingErrorEither,
  decode,
  decodeArray1,
  decodeBoolean1,
  decodeEither,
  decodeForeign,
  decodeInt1,
  decodeJSON,
  decodeJSONEither,
  decodeMap,
  decodeMaybe,
  decodeNonEmptyArray,
  decodeNumber1,
  decodeObject1,
  decodeRecord1,
  decodeRecordCons,
  decodeRecordNil,
  decodeSet,
  decodeString1,
  decodeTuple,
  decodeUnit,
  defaultFromJSONKeyValue,
  fromJSONKey,
  fromJSONKeyString,
  recordInfo,
  unsafeDecode,
  unsafeDecode1
};
export * from "./foreign.js";
